import { InformationPage } from "@/features/information/pages/Information";
import React from "react";

const Information = () => {
  return <InformationPage />;
};

export default Information;
